import { FC, Fragment, PropsWithChildren, useEffect } from "react";

import pusher from "utils/pusher";

type RealTimeWrapperProps = {
  channel: string;
  callBack?: (value: any) => void;
  events: string[];
};

const RealTimeWrapper: FC<PropsWithChildren<RealTimeWrapperProps>> = ({
  children,
  channel,
  callBack,
  events,
}) => {
  useEffect(() => {
    // try {
    const chnl = pusher.subscribe(channel);
    if (callBack) {
      events.forEach((event) => {
        // console.log("binding event", event, "to channel", channel);
        chnl.bind(event, (value: any) => {
          console.log("event", value, event);
          callBack?.(value);
        });
      });
    }

    // } catch (error) {
    //   console.error("---ERROR---", error);
    // }
    return () => {
      if (callBack) {
        events.forEach((event) => {
          chnl.unbind(event, callBack);
        });
      }
      pusher.unsubscribe(channel);
      //   pusher.disconnect();
    };
  }, [channel, callBack, events]);
  return <Fragment>{children}</Fragment>;
};

export default RealTimeWrapper;
